import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktTreatmentHeaderContainerModel } from '../../../../../../models';

@Injectable({
  providedIn: 'root',
})
export class DgMktTreatmentHeaderService extends BaseApiTemplateService<DgMktTreatmentHeaderContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'treatment-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatment-hdrs';
    this.endpoint_path =
      Core2Config.DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatment-hdrs';
    this.httpClient = http;
  }
}
